const turnstileReadyEvent = 'turnstileReady';

global.onTurnstileReadyHandler = function (callback) {
    global.addEventListener(turnstileReadyEvent, callback);
};

global.onloadTurnstileCallback = function () {
    const container = document.createElement('div');
    container.id = 'cf-turnstile-widget';
    document.body.appendChild(container);

    // Сохраняем ID виджета для последующего использования
    global.turnstileWidgetId = turnstile.render('#cf-turnstile-widget', {
        sitekey: global.turnstileSiteKey,
        callback: function(token) {
            global.turnstileToken = token;
            global.dispatchEvent(new CustomEvent(turnstileReadyEvent));
        },
        appearance: 'always'
    });
};

global.resetTurnstile = function () {
    if (typeof turnstile !== 'undefined' && global.turnstileWidgetId !== undefined) {
        turnstile.reset(global.turnstileWidgetId);
        global.turnstileToken = null;
    }
}
